import { ScrollView } from "../ScrollView.js";
import { IScrollViewScale } from "./IScrollViewScale.js";

export class ScrollViewScaleCover implements IScrollViewScale {
    public getScale(view: ScrollView): number {
        var scX = view.width / view.contentWidth;
        var scY = view.height / view.contentHeight;
        return Math.max(scX, scY);
    }
}